
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";

@Component({})
export default class GlobalSettings extends Vue {
	private loading: boolean = false;
	private saving: boolean = false;
	private loaded: boolean = false;
	private euroRate: number = 0;
	private euroValid: boolean = false;
	private requiredNumber0To2Rule: any = [
		(v: number) => !!v.toString() || "Angabe erforderlich",
		(v: number) => !isNaN(v) || "Muss eine Zahl sein.",
		(v: number) => v > 0 || "Muss > 0 sein.",
		(v: number) => v <= 2 || "Muss <= 2 sein.",
	];

	private mounted() {
		this.getGlobalSettings();
	}

	private async getGlobalSettings() {
		try {
			this.loading = true;
			const response = await httpClient().get("Settings/GetGlobalSettings");
			this.euroRate = response.data.euroRate;
			this.loaded = true;
		} catch {
			this.$store.commit(
				"setSnackbarErrorText",
				"Globale Einstellungen konnten nicht geladen werden."
			);
		} finally {
			this.loading = false;
		}
	}

	private async saveEuroRate() {
		try {
			this.saving = true;
			let data = { value: this.euroRate };
			const response = await httpClient().post(`Settings/SaveEuroRate`, data);
			this.$store.commit("setSnackbarText", "Euro-Kurs wurde angepasst.");
		} catch {
			this.$store.commit(
				"setSnackbarErrorText",
				"Euro-Kurs konnte nicht gespeichert werden."
			);
		} finally {
			this.saving = false;
		}
	}
}
